import * as yup from "yup";

const sellSubmitValidator = yup.object().shape({
	buyer: yup
		.string()
		.required("Name of buyer is requuired.")
		.min(3, "At least 3 characters required."),
	invoiceNo: yup.string().required("Invoice number required."),
});

export default sellSubmitValidator;
